import { render, staticRenderFns } from "./me-tablist.vue?vue&type=template&id=b5ca286a&scoped=true&"
import script from "./me-tablist.vue?vue&type=script&lang=js&"
export * from "./me-tablist.vue?vue&type=script&lang=js&"
import style0 from "./me-tablist.vue?vue&type=style&index=0&id=b5ca286a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ca286a",
  null
  
)

export default component.exports